import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, Move, X } from "lucide-react";
import { useState } from "react";

const SortableImage = ({ id, src, index, onRemove }) => {
    const [showDrag, setShowDrag] = useState(false);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="preview-item"
       onMouseEnter={() => setShowDrag(true)}
  onMouseLeave={() => setShowDrag(false)}
    >
      <div
         className={`drag-handle ${showDrag ? "show" : ""}`}
        {...attributes}
        {...listeners}
      >
        <Move  size={18} />
      </div>
      <a
        href={src}
        data-fancybox="gallery"
        data-caption={`Image ${index + 1}`}
      >
        <img
          src={src}
          alt={`preview-${index}`}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </a>

      {/* Remove */}
      <button
        type="button"
        className="remove-btn"

        onPointerDown={(e) => e.stopPropagation()}
        onMouseEnter={() => setShowDrag(false)}
    onMouseLeave={() => setShowDrag(true)}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onRemove(index);
        }}
      >
        <X size={14} />
      </button>
    </div>
  );
};

export default SortableImage;